import React from 'react';
import { useParams } from 'react-router-dom';
import PackageListSubscreen   from '../../../subscreens/customer/PublicCustomerSubscreens/packages/PackageListSubscreen.js';
import PackageDetailSubscreen from '../../../subscreens/customer/PublicCustomerSubscreens/packages/PackageDetailSubscreen';

const PackagesScreen = () => {
    const { id } = useParams();

    return id
        ? <PackageDetailSubscreen />
        : <PackageListSubscreen />;
};

export default PackagesScreen;